/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers'
import { Link, useNavigate } from 'react-router-dom'
import { fetchData, getEncryptedRoute, toasterrormsg, useMenuIdPermissions } from '../../../reusable'
import Swal from 'sweetalert2'

import { Hotels } from './components/settings/cards/property/Hotels'
import CafeRestaurant from './components/settings/cards/property/CafeRestaurant'
import SpaceRental from './components/settings/cards/property/SpaceRental'
import { VendorPersonalDetail } from './components/settings/cards/VendorPersonalDetail'
import TourPackage from './components/settings/cards/property/TourPackage'
import CarRental from './components/settings/cards/property/CarRental'
import { Tr } from '../../../_metronic/i18n/Tr'

const VendorHeader: React.FC = (props: any) => {
  let t = Tr()

  let vendorId = sessionStorage.getItem('locationVendorId') || ''
  vendorId = atob(vendorId)
  const { menuId, menuIdDelete, menuIdEdit } = useMenuIdPermissions()
  
  
  const navigate: any = useNavigate()
  const [fullName, setFullName] = useState('')
  const [email, setEmail] = useState('')
  const [propertyCount, setPropertyCount] = useState('')
  const [visitorsCount, setVisitorsCount] = useState('')
  const [categoryId, setCategoryId] = useState('')
  const [categoryName, setCategoryName] = useState('')

  const [imageUrl, setImageUrl] = useState('')
  const [businessInfostatus, setBusinessInfostatus] = useState(0)
  const [type, setType] = useState('details')

  const viewprofile = async () => {
    var param: any = {
      vendorId: String(vendorId),
    }
    var response: any = await fetchData('admin/viewvendorprofile', param)

    if (response.status == '200') {
      var data = response.data[0]

      setFullName(data['fullName'])
      setEmail(data['email'])
      setImageUrl(data['logo'])

      setBusinessInfostatus(data['businessInfostatus'])
      setVisitorsCount(data['Visitorscount'])

      setPropertyCount(data['propertyCount'])
      setCategoryId(data['categoryId'])
      setCategoryName(data['categoryName'])
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    viewprofile()
  }, [])

  // open reject conformation
  const rejectconfirmation = async (status: any, id: any) => {
    Swal.fire(
      status == '2'
        ? {
          title: 'Are You Sure? You Want to Reject This Vendor ID Proof Document.',
          icon: 'warning',
          showCancelButton: true,
          input: 'text',
          inputLabel: 'Reason',
          inputPlaceholder: 'Enter Reject Reason',
          inputValidator: (value) => {
            // Validate input here
            if (!value) {
              return 'Reject Reason Required!'
            }
          },
        }
        : {
          title: 'Are You Sure? You Want to Approve This Vendor Id Proof.',
          icon: 'warning',
          showCancelButton: true,
        }
    ).then(async (result) => {
      if (result.isConfirmed) {
        const inputValue = result.value
        if (status == '1') {
          var dataObj: any = {
            id: id,
            status: status,
            type: 'Vendor',
          }

          if (status == '2') {
            dataObj.reason = inputValue
          }

          var res = await fetchData('admin/businessDocStatusChange', dataObj)

          if (res.status == 200) {
            Swal.fire({
              title: 'Status Change Successfully !',
              icon: 'success',
            }).then((res) => {
              if (res.isConfirmed) {
                viewprofile()
              }
            })
          } else {
            Swal.fire({
              title: 'Something went Wrong !',
              icon: 'error',
            })
          }
        } else if (inputValue !== undefined && inputValue.trim() !== '' && status == '2') {
          var dataObj: any = {
            id: id,
            status: status,
            type: 'Vendor',
          }

          if (status == '2') {
            dataObj.reason = inputValue
          }

          var res = await fetchData('admin/businessDocStatusChange', dataObj)

          if (res.status == 200) {
            Swal.fire({
              title: 'Status Change Successfully !',
              icon: 'success',
            }).then((res) => {
              if (res.isConfirmed) {
                viewprofile()
              }
            })
          } else {
            Swal.fire({
              title: 'Something went Wrong !',
              icon: 'error',
            })
          }
        } else {
          // If input value is not valid, show error message
          Swal.fire({
            title: 'Invalid Input!',
            text: 'Please enter a valid reason.',
            icon: 'error',
          })
        }
      }
    })
  }

  // delete vendor
  const deletevendor = async (vendorId: any, name: any) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You Want To Delete ' + name + ' Vendor!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        var tmp: any = sessionStorage.getItem('admin')
        tmp = JSON.parse(tmp)

        try {
          var param: any = {
            vendorId: String(vendorId),
          }

          const response = await fetchData('admin/deleteVendor', param)

          if (response.status == '200') {
            Swal.fire({
              title: 'Vendor Deleted Successfully !',
              icon: 'success',
            }).then((res) => {
              if (res.isConfirmed) {
                navigate('../../')
              }
            })
          } else {
            Swal.fire({
              title: 'Something went Wrong !',
              icon: 'error',
            })
          }
        } catch (error) {
          // Handle error as needed
          toasterrormsg('An error occurred while processing your request.')
        }
      }
    })
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
            <div className='me-7 mb-4'>
              <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                <img
                  src={
                    imageUrl === '' || imageUrl === null
                      ? toAbsoluteUrl('/media/avatars/300-1.jpg')
                      : imageUrl
                  }
                  alt='vendor avatar'
                />
                <div className='position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px'></div>
              </div>
            </div>

            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div className='d-flex flex-column w-100'>
                  <div className='d-flex justify-content-between w-100'>
                    <div className='d-flex align-items-center mb-2'>
                      <a href='#' className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                        {fullName}
                      </a>
                      { }
                      {businessInfostatus == 0 ? (
                        <>
                          <span
                            title='Id Proof Is Not Verified'
                            className='cursor-pointer d-flex align-items-center'
                          >
                            <span className='badge badge-warning mx-2'>{t('Pending')}</span>
                          </span>
                        </>
                      ) : businessInfostatus == 1 ? (
                        <>
                          <span
                            title='Id Proof Is Verified'
                            className='cursor-pointer d-flex align-items-center'
                          >
                            {' '}
                            <span className='badge badge-success mx-2'>{t('Verified')}</span>
                          </span>
                        </>
                      ) : (
                        <>
                          <span
                            title='Id Proof Rejected'
                            className='cursor-pointer d-flex align-items-center'
                          >
                            <span className='badge badge-danger mx-2'>{t('Rejected')}</span>
                          </span>
                        </>
                      )}

                      {
                        <span
                          title='Id Proof Is Not Verified'
                          className='cursor-pointer d-flex align-items-center'
                        >
                          <span className='badge badge-info mx-2 fs-5'>
                            {' '}
                            {categoryId > '2' ? categoryName : 'Accommodation'}
                          </span>
                        </span>
                      }
                    </div>
                    <div>
                      {
                        <div className='mt-5'>
                          {!isNaN(businessInfostatus) && businessInfostatus == 0 ? (
                            <>
                              {menuIdEdit ?
                                <>
                                  <button
                                    className='btn btn-success btn-sm me-3'
                                    onClick={() => {
                                      rejectconfirmation('1', vendorId)
                                    }}
                                  >
                                    {t('Approve')}
                                  </button>
                                  <button
                                    className='btn btn-danger btn-sm me-3'
                                    onClick={() => {
                                      rejectconfirmation('2', vendorId)
                                    }}
                                  >
                                    {t('Reject')}
                                  </button>
                                </>
                                : ""}
                            </>
                          ) : ""}
                          {menuIdDelete ? <button
                            style={{ backgroundColor: 'orange', color: 'white' }}
                            className='btn btn-sm'
                            onClick={() => {
                              deletevendor(vendorId, fullName)
                            }}
                          >
                            {t('Delete')}
                          </button> : ""}
                        </div>
                      }
                    </div>
                  </div>

                  <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                    <div

                      className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                    >
                      <KTIcon iconName='profile-circle' className='fs-4 me-1' />
                      {t('Vendor')}
                    </div>

                    <div
                      className='d-flex align-items-center text-gray-400 text-hover-primary mb-2 pe-2'
                    >
                      <KTIcon iconName='sms' className='fs-4 me-1' />
                      {email}
                    </div>
                  </div>
                </div>
              </div>

              <div className='d-flex flex-wrap flex-stack'>
                <div className='d-flex flex-column flex-grow-1 pe-8'>
                  <div className='d-flex flex-wrap'>
                    <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                      <div className='d-flex align-items-center'>
                        <div className='fs-2 fw-bolder'>{visitorsCount}</div>
                      </div>

                      <div className='fw-bold fs-6 text-gray-400'>{t('Visitors')}</div>
                    </div>

                    <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                      <div className='d-flex align-items-center'>
                        <div className='fs-2 fw-bolder'>{propertyCount}</div>
                      </div>

                      <div className='fw-bold fs-6 text-gray-400'>{'Property'}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex overflow-auto h-55px'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
              <li className='nav-item'>
                <Link
                  onClick={() => {
                    setType('details')
                  }}
                  className={`nav-link text-active-primary me-6 ${type === 'details' ? 'active' : ''
                    }`}
                  state={vendorId}
                  to={getEncryptedRoute('', { menuId: menuId })}
                >
                  {t('Personal Details')}
                </Link>
              </li>

              <li className='nav-item'>
                <Link
                  onClick={() => {
                    setType('property')
                  }}
                  className={`nav-link text-active-primary me-6 ${type === 'property' ? 'active' : ''
                    }`}
                  state={vendorId}
                  to={getEncryptedRoute('', { menuId: menuId })}
                >
                  {t('Property')}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {type === 'details' ? (
        <VendorPersonalDetail />
      ) : (
        <>
          {categoryId == '1' && <Hotels />}
          {categoryId == '2' && <Hotels />}
          {categoryId == '3' && <CafeRestaurant />}
          {categoryId == '4' && <SpaceRental />}
          {categoryId == '5' && <TourPackage />}
          {categoryId == '7' && <CarRental />}
          {categoryId != '1' &&
            categoryId != '2' &&
            categoryId != '3' &&
            categoryId != '4' &&
            categoryId != '5' &&
            categoryId != '7' && <p>{t('No Property Available For the Selected Vendor')}</p>}
        </>
      )}
    </>
  )
}

export { VendorHeader }
